import PropTypes from 'prop-types';

import getUserRole from 'utils/jwt/getUserRole';
import logout from 'utils/logout';
import { useSnackbar } from 'notistack';

export function RoleRouter({ children, permittedRole = [] }) {
  const role = getUserRole();
  const { enqueueSnackbar } = useSnackbar();

  if (permittedRole?.includes(role)) {
    return children;
  }

  if (role !== permittedRole) {
    enqueueSnackbar('You do not have access', { variant: 'error' });
    return logout();
  }

  return children;
}

RoleRouter.propTypes = {
  children: PropTypes.node,
  permittedRole: PropTypes.array,
};
